import { questionIsHostScreen } from "../../../../../../projection/question/question.typeguards";
import { questionPosition } from "./questionPosition";
const nextQuestion = ({ question, questions }) => {
    const screens = questions.filter(questionIsHostScreen);
    const questionIndex = questionPosition({ question, questions });
    return screens[questionIndex + 1];
};
export { nextQuestion };
